import Vue from 'vue'

import Qs from 'qs'

class AuditLogs {
  async index({params}) {
    return await Vue.axios
      .get('app/audit-logs', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async read({id}) {
    return await Vue.axios
      .get('app/audit-logs/' + id)
  }
}

const auditLogs = new AuditLogs()

export default auditLogs
